import { selectUserInfo } from 'modules/auth/userSlice';
import { useContributors } from 'modules/contributors/useContributors';
import { selectOwner } from 'modules/threads/threadsSlice';
import { ReactElement } from 'react';
import { useAppSelector } from '../hooks';
import { EPermissions } from './constants';
import { hasAccess } from './utils';

interface IProps {
  permissions: EPermissions[];
  threadId: string;
  children: ReactElement;
  strict?: boolean;
}

const AccessControl = ({ permissions, threadId = '0', children, strict = true }: IProps) => {
  const userInfo = useAppSelector(selectUserInfo);
  const { id: ownerId } = useAppSelector(selectOwner(threadId));
  const { isCurrentUserContributor } = useContributors(threadId);
  const isPermitted = hasAccess(permissions, userInfo, ownerId, isCurrentUserContributor, strict);
  return isPermitted ? children : null;
};

export default AccessControl;
